import { WidgetExtended, WidgetParameterValueJson } from '@/types/dashboard'
import { computed, ComputedRef, Ref } from 'vue'

export default function useEntityPositiveNegativeFilters<T extends object, K extends keyof T> (
    widgetData: ComputedRef<WidgetExtended> | Ref<WidgetExtended>,
    parameterName: string,
    items: ComputedRef<T[]> | Ref<T[]>,
    key: K
) {
    const filters = computed<WidgetParameterValueJson>(() => {
        const res = widgetData.value?.WidgetConfig.find(el => el.ParameterName?.toLocaleLowerCase() === parameterName.toLocaleLowerCase())

        if (!res || !res.WidgetParameterValueJson || typeof res.WidgetParameterValueJson !== 'object') {
            return {
                EntityPositive: [],
                EntityNegative: []
            }
        }

        return res.WidgetParameterValueJson
    })

    const negativeSet = computed<Set<string | number> | null>(() => {
        const list = filters.value.EntityNegative
        return list?.length ? new Set(list) : null
    })

    const positiveSet = computed<Set<string | number> | null>(() => {
        const list = filters.value.EntityPositive
        return list?.length ? new Set(list) : null
    })

    const filteredItems = computed(() => {
        if (!items.value.length) {
            return []
        }

        if (negativeSet.value) {
            const neg = negativeSet.value
            return items.value.filter(el => {
                const val = el[key]

                if(typeof val === 'string' || typeof val === 'number') {
                    return !neg.has(val)
                }
                return false
            })
        }
        if (positiveSet.value) {
            const pos = positiveSet.value
            return items.value.filter(el =>  {
                const val = el[key]
                if(typeof val === 'string' || typeof val === 'number') {
                    return pos.has(val)
                }
                return false
            })
        }
        return items.value
    })

    return {
        filters,
        filteredItems
    }
}
